import { useState } from "react";
import { WarningTick, ExitTick } from "components/assets/Icons";

import styles from "./styles.module.scss";

const PopUpWarning = ({ text }) => {
  const [hidePopUp, setHidePopUp] = useState(false);

  // setTimeout(() => setHidePopUp(true), 2000);
  // TODO: add close butoon
  return (
    !hidePopUp && (
      <div className={styles.wrapper}>
        <WarningTick />
        <div className={styles.content}>
          <h2 className={styles.title}>OOPS!</h2>
          <p className={styles.message}>RfQ with Order ID 
            <strong> {text?.order_number}</strong> is {text?.status_type} to 
            <b> {text?.user_made_action ? text.user_made_action : "someone"}</b> at 
            <b> {text?.action_datetime ? text.action_datetime : "sometime"}</b></p>
        </div>
        <div className={styles.exit} onClick={() => setHidePopUp(true)}>
          <ExitTick />
        </div>
      </div>
    )
  );
};

export default PopUpWarning;
